import { render } from "./Gallery.vue?vue&type=template&id=702d43c2&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=702d43c2&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-702d43c2"

export default script